module.exports = __webpack_public_path__ + "static/media/AS.0d605114.svg";